export default "__VITE_ASSET__ZOKEvv0q__"